
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/album",
      function () {
        return require("private-next-pages/album.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/album"])
      });
    }
  